import { FaChevronLeft } from "react-icons/fa";
import MeritoButton from "../../MeritoButtons/MeritoButtons";
import successCheckIcon from "../../../../resources/images/gst-recon/tally-sync-success-check.svg";
import sharedStyles from "../TallySyncShared.module.scss";
import styles from "./TallySyncSuccess.module.scss";

interface TallySyncSuccessProps {
  isDashboard?: boolean;
}

export default function TallySyncSuccess({
  isDashboard = false,
}: TallySyncSuccessProps) {
  const successPanel = (
    <div className={styles.successPanel}>
      <div className={styles.successMessage}>
        <div className={styles.successBadge}>
          <span className={styles.successIcon} aria-hidden="true">
            <img src={successCheckIcon} alt="" />
          </span>
        </div>
        <h1 className={styles.successTitle}>Data Sync Successful</h1>
        <p className={styles.successDescription}>
          Your invoices have been sent to Merito.
        </p>
      </div>
    </div>
  );

  if (isDashboard) {
    return <div className={styles.dashboardContent}>{successPanel}</div>;
  }

  return (
    <div className={sharedStyles.page}>
      <div className={`${sharedStyles.shell} ${sharedStyles.compactShell}`}>
        <MeritoButton
          type="secondary-1"
          size="md2"
          className={`${sharedStyles.backBtn} ${sharedStyles.disabledBackBtn}`}
          disabled
          icon={
            <span className={sharedStyles.backIcon} aria-hidden="true">
              <FaChevronLeft />
            </span>
          }
          btnText="Back"
        />

        <div
          className={`${sharedStyles.card} ${sharedStyles.compactCard} ${styles.successCard}`}
        >
          <div className={styles.successContent}>
            <div className={styles.successHeader}>
              <p className={sharedStyles.stepLabel}>
                STEP 2 OF 2 • Connect Automatically
              </p>
            </div>

            {successPanel}
          </div>
        </div>
      </div>
    </div>
  );
}
